module.exports = __webpack_public_path__ + "img/ico_external-link--black.94f76a7e.svg";